// 全局 fetch 拦截器：对 banned:true 的 403 统一登出。
// 跳转副作用抽成 clearSessionAndRedirect；installBannedInterceptor 接受可注入的
// onBanned（默认即跳转），便于单测 mock，避免改写 window.location。
// 仅在“有会话(token)”时触发：未登录场景（封禁用户登录，login 也回 banned:true）
// 不弹走，以便登录页展示“账号已被封禁”。一处覆盖全仓所有 fetch（含未来新增）。
export function clearSessionAndRedirect(): void {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  window.location.href = '/';
}

export function installBannedInterceptor(onBanned: () => void = clearSessionAndRedirect): void {
  const origFetch = window.fetch.bind(window);
  window.fetch = async (...args: Parameters<typeof fetch>): Promise<Response> => {
    const res = await origFetch(...args);
    if (res.status === 403 && localStorage.getItem('token')) {
      const body = await res.clone().json().catch(() => ({} as any));
      if (body && body.banned === true) onBanned();
    }
    return res;
  };
}
